function scrollToDivByIdDomUtil (divId, direction = 'down') {
  const targetElement = document.getElementById(divId)

  if (!targetElement) {
    return
  }

  if (direction === 'up') {
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
    return
  }

  targetElement.scrollIntoView({
    behavior: 'smooth',
    block: 'end'
  })
}

export default scrollToDivByIdDomUtil
